import React, { useState } from 'react';
import {
    Box,
    Chip,
    Grid,
    LinearProgress,
    Paper,
    Stack,
    Typography,
} from '@mui/material';

import ReportSection from './ReportSection';
import OrderServiceStatusDetailDialog from './OrderServiceStatusDetailDialog';

import { ORDER_STATUS_FLOW } from '../utils/orderServiceReportConfig';
import { formatMoney, formatNumber, percentage, toNumber } from '../utils/formatters';

const OrderServiceStatusFlow = ({ byStatus = [], totalOrders = 0, filters = {} }) => {    
    const [selectedStatus, setSelectedStatus] = useState(null);

    const byStatusMap = byStatus.reduce((acc, item) => {
        acc[item.status] = item;
        return acc;
    }, {});

    const handleOpenStatus = (status) => {
        setSelectedStatus(status);
    };

    const handleCloseStatus = () => {
        setSelectedStatus(null);
    };

    return (
        <>
            <ReportSection
                title="Flujo de órdenes de servicio"
                subtitle="Haz clic en un estado para ver sus órdenes y manifiestos asociados"
            >
                <Grid container spacing={1.5}>
                    {ORDER_STATUS_FLOW.map((status) => {
                        const item = byStatusMap[status.key] || {};
                        const quantity = toNumber(item.quantity);
                        const amount = toNumber(item.amount);
                        const progress = percentage(quantity, totalOrders);

                        return (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={status.key}>
                                <Paper
                                    variant="outlined"
                                    onClick={() => handleOpenStatus(status.key)}
                                    sx={{
                                        p: 1.5,
                                        borderRadius: 2.5,
                                        height: '100%',
                                        cursor: 'pointer',
                                        bgcolor: quantity > 0 ? 'background.paper' : 'action.hover',
                                        transition: '0.2s ease',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: 3,
                                            borderColor: 'primary.main',
                                        },
                                    }}
                                >
                                    <Stack spacing={1}>
                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                            <Chip
                                                size="small"
                                                label={status.label}
                                                color={status.color}
                                                variant={quantity > 0 ? 'filled' : 'outlined'}
                                            />

                                            <Typography variant="caption" color="text.secondary">
                                                {progress}%
                                            </Typography>
                                        </Stack>

                                        <Box>
                                            <Typography variant="h5" fontWeight={900}>
                                                {formatNumber(quantity)}
                                            </Typography>

                                            <Typography variant="caption" color="text.secondary">
                                                {status.phase}
                                            </Typography>
                                        </Box>

                                        <LinearProgress
                                            variant="determinate"
                                            value={progress}
                                            sx={{ height: 8, borderRadius: 99 }}
                                        />

                                        <Typography variant="body2" fontWeight={800}>
                                            {formatMoney(amount)}
                                        </Typography>
                                    </Stack>
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>
            </ReportSection>

            <OrderServiceStatusDetailDialog
                open={Boolean(selectedStatus)}
                onClose={handleCloseStatus}
                status={selectedStatus}
                filters={filters}
            />
        </>
    );
};

export default OrderServiceStatusFlow;